// @ts-nocheck

import { useAtomValue } from 'jotai';

import React from 'react';
import cn from 'classnames';
import { Col, Row } from 'react-bootstrap';
import { languageAtom } from '@shared/store/slice-atoms';
import { useTranslation } from 'react-i18next';

import styles from '../styles/VipFeatures.module.css';
import { isWhiteDependingOnDOM } from '@shared/utils';
import { CLOUDFRONT_LANDING_PAGE_ROOT_URL } from '@shared/config/constants/app';

export const VipFeatures = ({ vipFeaturesConfig = {} }) => {
  const { hide } = vipFeaturesConfig;
  const { t } = useTranslation();
  const language = useAtomValue(languageAtom);

  if (hide) {
    return null;
  }

  const whiteIconText = isWhiteDependingOnDOM() ? '-w' : '';

  return (
    <>
      <Row className="">
        <Col>
          <div className="text-center">
            <p className={cn(styles['plus-features'], 'fs-12')}>
              {language.locale === 'ar' ? (
                <span>{t('features')}</span>
              ) : (
                <span className="fw-bold">{t('plus')}</span>
              )}{' '}
              {language.locale === 'ar' ? (
                <span className="fw-bold">{t('plus')}</span>
              ) : (
                <span>{t('features')}</span>
              )}
            </p>
          </div>
        </Col>
      </Row>

      <Row className="mb-4">
        <div className={cn('col-2', styles['benefit-col-1'])}>
          <img
            alt={t('vip_benefits_1')}
            src={`${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/mobile-subscription/adsfree-ic${whiteIconText}.webp`}
            className={cn('img-fluid', styles['benefit-img'])}
            width="100%"
            height="100%"
          />
        </div>
        <div className={cn('col-4', styles['benefit-col-2'], 'pfix1')}>
          <p className={styles['benefit-txt']}>{t('vip_benefits_1')}</p>
        </div>

        <div className={cn('col-2', styles['benefit-col-1'])}>
          <img
            alt={t('vip_benefits_2')}
            src={`${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/mobile-subscription/library360-ic${whiteIconText}.webp`}
            className={cn('img-fluid', styles['benefit-img'])}
            width="100%"
            height="100%"
          />
        </div>
        <div className={cn('col-4', styles['benefit-col-2'], 'pfix2')}>
          <p className={styles['benefit-txt']}>{t('vip_benefits_2')}</p>
        </div>

        <div className={cn('col-2', styles['benefit-col-1'])}>
          <img
            alt={t('vip_benefits_3')}
            src={`${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/mobile-subscription/exclusive360-ic${whiteIconText}.webp`}
            className={cn('img-fluid', styles['benefit-img'])}
            width="100%"
            height="100%"
          />
        </div>
        <div className={cn('col-4', styles['benefit-col-2'])}>
          <p className={styles['benefit-txt']}>{t('vip_benefits_3')}</p>
        </div>

        <div className={cn('col-2', styles['benefit-col-1'])}>
          <img
            alt={t('vip_benefits_4')}
            src={`${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/mobile-subscription/cancelanytime-ic${whiteIconText}.webp`}
            className={cn('img-fluid', styles['benefit-img'])}
            width="100%"
            height="100%"
          />
        </div>
        <div className={cn('col-4', styles['benefit-col-2'], 'pfix1')}>
          <p className={styles['benefit-txt']}>{t('vip_benefits_4')}</p>
        </div>

        <div className={cn('col-2', styles['benefit-col-1'])}>
          <img
            alt={t('vip_benefits_5')}
            src={`${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/mobile-subscription/merchdiscount-ic${whiteIconText}.webp`}
            className={cn('img-fluid', styles['benefit-img'])}
            width="100%"
            height="100%"
          />
        </div>
        <div className={cn('col-4', styles['benefit-col-2'], 'pfix2')}>
          <p className={styles['benefit-txt']}>{t('vip_benefits_5')}</p>
        </div>

        <div className={cn('col-2', styles['benefit-col-1'])}>
          <img
            alt={t('vip_benefits_6')}
            src={`${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/mobile-subscription/unlimitedwatch-ic${whiteIconText}.webp`}
            className={cn('img-fluid', styles['benefit-img'])}
            width="100%"
            height="100%"
          />
        </div>
        <div className={cn('col-4', styles['benefit-col-2'], 'pfix2')}>
          <p className={styles['benefit-txt']}>{t('vip_benefits_6')}</p>
        </div>
      </Row>

      <div className="line-separator-1 my-2" />
    </>
  );
};
